import { render, staticRenderFns } from "./ImportArticle.vue?vue&type=template&id=616b5e5e&scoped=true"
import script from "./ImportArticle.vue?vue&type=script&lang=ts"
export * from "./ImportArticle.vue?vue&type=script&lang=ts"
import style0 from "./ImportArticle.vue?vue&type=style&index=0&id=616b5e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616b5e5e",
  null
  
)

export default component.exports